import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { SELECT_EXPORT_PAGES } from "@/Constants/common";
import {
  fetchAuthorisedTimesheets,
  updatePagination,
  setAuthorisedTimesheetsLoading,
} from "@/reducers/timesheets/timesheetauthorised";
import { fetchTimesheetCount } from "@/reducers/timesheets/timesheets";
import { toastMessageText } from "@/utilities/CommonText";

import { _exportAuthorisedTimesheets } from "../../../../../../services/clientexport";
import ExportButton from "../../../ActionButtons/ExportButton";
import InvoiceTimesheet from "../../../candidates/Listing/Authorized/InvoiceTimesheet";

const Actions = () => {
  const {
    pagination,
    selectedCandidate,
    authorisedTimesheets,
    isSelectedAll,
    selectedSignOffIds,
  } = useSelector((state) => state.clientTimesheetAuthorised);
  const dispatch = useDispatch();
  const { clientUserAllPermissions } = useSelector((state) => state.session);

  const handleReloadTable = () => {
    dispatch(fetchTimesheetCount());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setAuthorisedTimesheetsLoading(true));
    dispatch(fetchAuthorisedTimesheets());
  };
  return (
    <>
      <div className="Actions_Wrapper tour-authorised-actions">
        <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
          <ExportButton
            page={SELECT_EXPORT_PAGES.AUTHORISED}
            // exportUrl={routingConstants.exportAuthorised}
            exportFunction={_exportAuthorisedTimesheets}
            selectedTablesData={selectedSignOffIds}
            ignoreIds={
              isSelectedAll
                ? authorisedTimesheets
                    .filter(
                      (ele) => !selectedSignOffIds.includes(ele.timesheet_id),
                    )
                    .map((ele) => ele.timesheet_id)
                    .join(",")
                : ""
            }
            isSelectedAll={isSelectedAll}
            extraObj={{
              timesheet_ids: selectedSignOffIds.join(","),
            }}
            emptyExportMessage={toastMessageText.emptyExportMessageForContract}
          />
          <InvoiceTimesheet />
        </div>
      </div>
    </>
  );
};

export default Actions;
